module.exports = __webpack_public_path__ + "static/logo-cec7600dd4e1e13b428c086994ab1cfd.png";